/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./agreement.vue.js?vue&type=template&id=48ee064c!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./agreement.vue?vue&type=template&id=48ee064c"
import script from "./agreement.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./agreement.vue?vue&type=script&setup=true&lang=js"
export * from "./agreement.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./agreement.vue?vue&type=script&setup=true&lang=js"
import style0 from "./agreement.vue.postcss?vue&type=style&index=0&id=48ee064c&prod&lang=postcss&module=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./agreement.vue?vue&type=style&index=0&id=48ee064c&prod&lang=postcss&module=true"
import style1 from "./agreement.vue.postcss?vue&type=style&index=1&id=48ee064c&prod&lang=postcss!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./agreement.vue?vue&type=style&index=1&id=48ee064c&prod&lang=postcss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports